import { render, staticRenderFns } from "./CalledCard.vue?vue&type=template&id=7ef6ccfc&scoped=true&"
import script from "./CalledCard.vue?vue&type=script&lang=js&"
export * from "./CalledCard.vue?vue&type=script&lang=js&"
import style0 from "./CalledCard.vue?vue&type=style&index=0&id=7ef6ccfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef6ccfc",
  null
  
)

export default component.exports